import JSEncrypt from 'jsencrypt'
import 'capacitor-secure-storage-plugin'
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin'

export class KeyManager {
  constructor() {
    this.secureStorage = SecureStoragePlugin
  }

  generateKeyPair(userId) {
    const keyPair = new JSEncrypt()
    const key = 'keys' + userId
    const value = JSON.stringify({
      publicKey: keyPair.getPublicKeyB64(),
      privateKey: keyPair.getPrivateKeyB64()
    })

    return this.secureStorage.set({ key, value })
  }

  getKeyPair(userId) {
    return new Promise((resolve, reject) => {
      this.secureStorage.get({ key: 'keys' + userId }).then(keys => {
        if (typeof keys === 'undefined' || keys.value === '\u009eée') {
          reject(new Error('Could not find key'))
        } else {
          resolve(JSON.parse(keys.value))
        }
      }).catch(err => reject(new Error(err)))
    })
  }
}

export function getKeyManager() {
  const keyManager = new KeyManager()
  return keyManager
}
